var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "usdc",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M16,32A15.961,15.961,0,1,0,4.674,27.325,16,16,0,0,0,16,32Z",
    transform: "translate(0.001)",
    fill: "#2775ca"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M189.772,138.305c0-2.133-1.28-2.864-3.839-3.168-1.828-.244-2.193-.731-2.193-1.584s.609-1.4,1.828-1.4a1.8,1.8,0,0,1,2.011,1.28.462.462,0,0,0,.427.3h.975a.417.417,0,0,0,.426-.426v-.061a3.044,3.044,0,0,0-2.742-2.5v-1.462c0-.244-.183-.426-.488-.488h-.914c-.244,0-.427.183-.488.488v1.4a3.107,3.107,0,0,0-2.986,2.986c0,2.011,1.218,2.8,3.777,3.108,1.707.3,2.255.67,2.255,1.645s-.853,1.645-2.011,1.645c-1.584,0-2.135-.671-2.315-1.584a.446.446,0,0,0-.426-.366h-1.035a.417.417,0,0,0-.427.426v.061a3.4,3.4,0,0,0,3.232,2.925V143c0,.244.182.427.487.488h.914c.244,0,.426-.183.487-.488v-1.462a3.338,3.338,0,0,0,3.047-3.232Z",
    transform: "translate(-169.758 -119.961)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M71.706,95.462a10.275,10.275,0,0,1-6.1-13.226,10.172,10.172,0,0,1,6.1-6.133.692.692,0,0,0,.411-.689v-.962a.524.524,0,0,0-.411-.551.411.411,0,0,0-.275.069,12.414,12.414,0,0,0,0,23.628.417.417,0,0,0,.618-.275c.068-.069.068-.138.068-.275v-.964A.918.918,0,0,0,71.706,95.462Zm7.267-21.49a.416.416,0,0,0-.617.275c-.069.069-.069.138-.069.276v.962a.914.914,0,0,0,.411.688,10.325,10.325,0,0,1,0,19.36.692.692,0,0,0-.411.689v.964a.523.523,0,0,0,.411.551.414.414,0,0,0,.275-.069,12.466,12.466,0,0,0,0-23.7Z",
    transform: "translate(-59.203 -69.635)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.4a3e1e4e6b4eab91b0e28a470c6bdb2b.svg";
export { ForwardRef as ReactComponent };